import {CreateProfilePage} from "@/features/onboarding/pages/CreateProfilePage.jsx";
import {RequireAuth} from "@/features/auth/components/RequireAuth.jsx";
import {DefaultHouseholdPage} from "@/features/onboarding/pages/DefaultHouseholdPage.jsx";
import {CreateHouseholdPage} from "@/features/onboarding/pages/CreateHouseholdPage.jsx";
import {AcceptInvitationPage} from "@/features/onboarding/pages/AcceptInvitationPage.jsx";

export const onboardingRoutes = {
  element: <RequireAuth/>,
  children: [{
    path: 'default-household',
    element: <DefaultHouseholdPage/>,
  }, {
    path: 'onboarding/create-profile',
    element: <CreateProfilePage/>,
  }, {
    path: 'onboarding/create-household',
    element: <CreateHouseholdPage/>,
  }, {
    path: 'invitations/:id/accept',
    element: <AcceptInvitationPage/>,
  }],
};
